import { Box, Center, Group, Stack, UnstyledButton } from '@mantine/core';
import { useState } from 'react';
import ShareInviteLink from '@projectMembers/components/ShareInviteLink/ShareInviteLink';
import Icon from '@ui/components/Icon/Icon';
import Text from '@ui/components/Text/Text';
import OverviewPermissionTooltip from 'src/new_arch/modules/projectView/components/OverviewPermissionTooltip/OverviewPermissionTooltip';
import { UPGRADE_REQUEST_SOURCES } from 'src/new_arch/modules/projectView/components/OverviewPermissionTooltip/upgradeRequestSources';
import Project from 'src/entities/project';

import ManageReviewerRoleModal from '../../ManageReviewerRoleModal/ManageReviewerRoleModal';
import ViewOnlyLinkRow from '../ViewOnlyLinkRow/ViewOnlyLinkRow';

const SUBMODALS_STACK_ORDER = 2;

type ShareLinksSectionProps = {
	project: Project;
	showManageReviewerRole: boolean;
	showViewOnlyLink: boolean;
	viewOnlyWithDownloads: boolean;
	onViewOnlyWithDownloadsChange: ( enabled: boolean ) => void;
};

const ShareLinksSection = ( {
	project, showManageReviewerRole, showViewOnlyLink, viewOnlyWithDownloads, onViewOnlyWithDownloadsChange
}: ShareLinksSectionProps ) => {
	const [ isShowingCustomizeModal, setIsShowingCustomizeModal ] = useState( false );

	return (
		<Box bg="var(--color-bg-container)" px={20} py={16} style={{ borderRadius: 4 }}>
			<Stack spacing={10}>
				<Group position="apart" align="center">
					<Group spacing={4}>
						<Center bg="var(--color-bg-surface-dim)" p={4} style={{ borderRadius: 4 }}>
							<Icon icon="public" size={14} color="blue.5" />
						</Center>
						<Text variant="footnote-semibold" color="var(--color-text-primary)">Share link</Text>
						<Box
							px={5}
							py="3px"
							style={{
								border: '1px solid var(--color-outline-light)',
								borderRadius: 4,
								backgroundColor: 'var(--color-bg-surface)',
								display: 'inline-flex'
							}}
						>
							<Text variant="caption-semibold" color="var(--color-text-primary)">No account Required</Text>
						</Box>
					</Group>
					{showManageReviewerRole ? (
						<UnstyledButton
							onClick={() => setIsShowingCustomizeModal( true )}
							style={{ display: 'flex', alignItems: 'center', gap: 3 }}
						>
							<Icon icon="settings_outlined" size={14} color="var(--color-text-secondary)" />
							<Text variant="caption-semibold" color="var(--color-text-secondary)">Customize</Text>
						</UnstyledButton>
					) : (
						<OverviewPermissionTooltip
							projectID={project.id}
							source={UPGRADE_REQUEST_SOURCES.MANAGER_REVIEWER_ROLE}
						>
							<UnstyledButton style={{ display: 'flex', alignItems: 'center', gap: 3, opacity: 0.5 }}>
								<Icon icon="settings_outlined" size={14} color="var(--color-text-secondary)" />
								<Text variant="caption-semibold" color="var(--color-text-secondary)">Customize</Text>
							</UnstyledButton>
						</OverviewPermissionTooltip>
					)}
				</Group>

				<ShareInviteLink project={project} />
				{showViewOnlyLink && (
					<ViewOnlyLinkRow project={project} withDownloads={viewOnlyWithDownloads} />
				)}
			</Stack>

			{isShowingCustomizeModal && (
				<ManageReviewerRoleModal
					project={project}
					onClose={() => setIsShowingCustomizeModal( false )}
					stackOrder={SUBMODALS_STACK_ORDER}
					viewOnlyWithDownloads={viewOnlyWithDownloads}
					onViewOnlyWithDownloadsChange={onViewOnlyWithDownloadsChange}
				/>
			)}
		</Box>
	);
};

export default ShareLinksSection;
